/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';

export default function SaveAutoSummary(props)
{
    const [saveAutoSummary, setSaveAutoSummary] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setSaveAutoSummary(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleSaveAutoSummary = () => {
        setSaveAutoSummary(!saveAutoSummary);
        props.onChange(!saveAutoSummary)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={saveAutoSummary}
                        onChange={handleSaveAutoSummary}
                        name="saveAutoSummary"
                        color="primary"
                        />
                    }
                    label="Save Auto Summary"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Save Auto Summary by default">
                        <DescriptionIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

